import { passDeflate } from './socket'

export const hashRank = () => passDeflate('devHashRank')
